const plugin = {
  install : function (Vue) {

  }
}

export default  plugin



// WEBPACK FOOTER //
// ./src/plugin/index.js